export const initRecoveryData = 'Account/InitDataRecoverySession';
export const verifyRecoveryOtp1 = 'Account/VerifyOtp1ForDataRecoverySession';
export const refreshRecoveryOtp1 =
  'Account/RefreshAuthOtp1ForDataRecoverySession';
export const verifyRecoveryOtp2 = 'Account/VerifyOtp2ForDataRecoverySession';
export const refreshRecoveryOtp2 =
  'Account/RefreshAuthOtp2ForDataRecoverySession';
export const performRecoveryData = 'Account/PerformDataRecoverySession';
